import { alpha, useTheme } from '@mui/material/styles'
import { ChatHeader } from './ChatHeader'
import { MessageList } from './MessageList'
import { MessageInput } from './MessageInput'
import { TypingIndicator } from './TypingIndicator'
import { useChat } from '../context/useChat'

export const ChatWindow = () => {
  const theme = useTheme()
  const {
    loading,
    error,
    messages,
    typingParticipant,
    connectionState,
    retryConnection,
  } = useChat()
  const showConnectionWarning =
    connectionState === 'disconnected' || connectionState === 'disconnecting'

  return (
    <div className="h-full w-full bg-[#F6F7F9]">
      <div className="flex flex-col h-full bg-white">
        <ChatHeader />

        {showConnectionWarning && (
          <div className="flex items-center justify-between px-4 py-2 mx-6 mt-2 text-sm border rounded-xl border-amber-200 bg-amber-50 text-amber-700">
            <span>Connection interrupted. Trying to reconnect…</span>
            <button
              type="button"
              onClick={retryConnection}
              className="rounded-lg bg-amber-600 px-3 py-1.5 text-xs font-semibold text-white transition hover:bg-amber-700"
            >
              Retry
            </button>
          </div>
        )}

        <div className="relative flex-1 overflow-hidden">
          {loading && (
            <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-3 bg-white/80 backdrop-blur-sm">
              <div
                className="h-10 w-10 animate-spin rounded-full border-[3px]"
                style={{
                  borderColor: alpha(theme.palette.primary.main, 0.12),
                  borderTopColor: theme.palette.primary.main,
                }}
              />
              <p className="text-sm font-medium text-slate-500">
                Loading messages…
              </p>
            </div>
          )}

          {!loading && error && messages.length === 0 && (
            <div className="flex flex-col items-center justify-center h-full px-6 text-center">
              <div className="px-8 py-10 border shadow-sm rounded-2xl border-slate-100 bg-slate-50">
                <p className="text-base font-semibold text-slate-700">
                  Unable to connect
                </p>
                <p className="max-w-xs mx-auto mt-2 text-sm leading-relaxed text-slate-500">
                  {error}
                </p>
                <button
                  type="button"
                  onClick={retryConnection}
                  className="px-5 py-2 mt-5 text-sm font-semibold text-white transition rounded-full hover:opacity-90"
                  style={{
                    background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                  }}
                >
                  Try again
                </button>
              </div>
            </div>
          )}

          {!loading && (!error || messages.length > 0) && (
            <MessageList
              messages={messages}
              footer={typingParticipant ? <TypingIndicator /> : null}
            />
          )}
        </div>

        <div className="px-6 py-4 border-t border-slate-100">
          <MessageInput />
        </div>
      </div>
    </div>
  )
}
